/*
   Alan
   Customising react-select-me
   https://github.com/maslianok/react-select-me

   options: [{value: "1", label: "One"}, {value: "2", label: "Two"}]
*/
import "./select.scss";
import Select from "react-select-me";
import "react-select-me/lib/ReactSelectMe.css";
import { Loader } from "rsuite";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ErrorTooltip from "components/ErrorTooltip/ErrorTooltip";
import { useState } from "react";
import Fuse from "fuse.js";

function CustomSelect({
  defaultValue = [],
  value = [],
  wrapperClass = "",
  selectControlClass = "",
  listClass = "",
  optionsClass = "",
  selectedOptionClass = "",
  type = "primary",
  rounded = false,
  size = "md",
  options = [],
  multiple = false,
  searchable = false,
  onChange,
  optionOutlined = false,
  searchIcon = false,
  selectedItemClass,
  error = null,
  errorVariant,
  loading = false,
  label,
  labelClass,
  labelWrapperClass,
  ...rest
}) {
  const [searchResult, seatSearchResult] = useState(options);

  // overriding default styles
  const classNames = {
    dd__wrapper: `${type === "primary" ? "cif__select-wrapper" : ""} ${
      type === "transparent" ? "cif__select-wrapper-transparent" : ""
    } ${multiple ? "cif__select-wrapper-multiple-" + type : ""}
    ${type === "underlined" ? "cif__select_underlined_wrapper" : ""} 
    ${wrapperClass}`,
    dd__selectControl: ` ${type === "primary" ? "cif__select-control" : ""}  ${
      type === "secondary" ? "cif__select-secondary cif__select-control" : ""
    } ${type === "ternery" ? "cif__select-ternery cif__select-control" : ""} ${
      rounded === true ? "cif__select-rounded" : ""
    }
      ${type === "transparent" ? "cif__select-control-transparent" : ""} 
      ${type === "underlined" ? "cif__select_underlined_control" : ""}
      ${selectControlClass}`,
    dd__option: `${
      type === "transparent"
        ? "cif__select-option-transparent"
        : "cif__select-option"
    }  
    ${type === "underlined" ? "cif__select_underlined_option" : ""}
    ${optionOutlined ? "cif__select-option-transparent" : ""}
    ${optionsClass}`,
    dd__selectedOption: ` ${
      type === "transparent"
        ? "cif__select-selected-option-transparent"
        : "cif__select-selected-option"
    }  
    ${type === "underlined" ? "cif__select_underlined_selected_option" : ""}
    ${selectedOptionClass}`,
    dd__list: `${optionOutlined ? "cif__select_list_borderless" : ""}`,
    dd__selectedItem: `${selectedItemClass}`,
  };

  // function to render icon
  const renderIcon = (isOpen) => {
    if (loading) {
      return <Loader />;
    }
    if (!searchIcon && !loading) {
      return (
        <span className="material-icons">
          {isOpen ? "keyboard_arrow_up" : "keyboard_arrow_down"}
        </span>
      );
    }
    if (searchIcon) {
      return (
        <span className="material-icons font-md-2 cif__text_secondary">
          search
        </span>
      );
    }
  };

  const handleSearch = (string) => {
    const config = {
      includeScore: true,
      keys: ["value", "label"],
      isCaseSensitive: true,
      threshold: 0.0,
    };
    const fuse = new Fuse(options, config);
    let result = fuse.search(string);
    let arr = [];
    result.forEach((item) => {
      arr.push(item.item);
    });
    seatSearchResult(arr);
    console.log("search result : ", result);
  };

  const handleOpen = () => {
    seatSearchResult(options);
  };

  return (
    <>
      <div className={labelWrapperClass}>
        <label className={labelClass}>{label}</label>
        {error && <ErrorTooltip errorVariant={errorVariant} text={error} />}
      </div>
      <Select
        s={classNames}
        value={value}
        onChange={onChange}
        options={searchable ? searchResult : options}
        onOpen={searchable ? handleOpen : null}
        iconRenderer={renderIcon}
        multiple={multiple}
        searchable={searchable}
        onSearch={handleSearch}
        {...rest}
      />
    </>
  );
}

export default CustomSelect;
